import main from "./main";
import mindmapAPI from './mindmapAPI.js'
import cardAPI from './cardAPI.js'
import MyAzTokenProvider from "./myAzTokenProvider";
export default {
    main,mindmapAPI,cardAPI,MyAzTokenProvider
};
